import { Alert, Button } from 'antd';
import { RouteContentSkeleton } from '@/components/LoadingSkeleton';
import { useShellText } from '@/hooks/useShellText';

export function AccountFeedback({
  pending,
  error,
  retry,
}: {
  pending?: boolean;
  error?: Error | null;
  retry?: () => void;
}) {
  const t = useShellText();
  if (error)
    return (
      <Alert
        type="error"
        showIcon
        title={t('加载失败', 'Unable to load')}
        description={error.message}
        action={
          retry && (
            <Button aria-label={t('重试', 'Retry')} onClick={retry}>
              {t('重试', 'Retry')}
            </Button>
          )
        }
      />
    );
  if (pending) return <RouteContentSkeleton />;
  return null;
}
